import { TextField } from '@mui/material';
import { useState } from 'react';

import { updateTenant } from '../../api/admin/endpoints';
import type { TenantDetail } from '../../api/admin/types';
import { useAppMutation } from '../../api/useAppMutation';
import { FormDialog } from '../../components/FormDialog';
import { useT } from '../../i18n/LanguageContext';

export const EditTenantDialog = ({ tenant, onClose }: { tenant: TenantDetail; onClose: () => void }) => {
  const t = useT();
  const [name, setName] = useState(tenant.name);
  const [contactEmail, setContactEmail] = useState(tenant.contactEmail ?? '');
  const mutation = useAppMutation(
    () => updateTenant(tenant.id, { name: name.trim(), contactEmail: contactEmail.trim() }),
    ['tenant', 'tenants', 'audit'],
    onClose,
  );

  return (
    <FormDialog
      title={t('tenants.edit')}
      onClose={onClose}
      onSubmit={() => mutation.mutate(undefined)}
      isBusy={mutation.isPending}
      error={mutation.error}
    >
      <TextField
        required
        label={t('field.tenantName')}
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <TextField
        type="email"
        label={t('field.contactEmail')}
        value={contactEmail}
        onChange={(e) => setContactEmail(e.target.value)}
      />
    </FormDialog>
  );
};
